import {
    SkyNetTableSort,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

const injectSort = (defaultSort?:SkyNetTableSort) => {
    return (cb) => {
        return (params) => {
            const {
                sort,
            } = params

            return cb({
                ...params,
                sort: sort || defaultSort || {
                    field: 'changedOn',
                    direction: 'desc',
                },
            })
        }
    }
}

export default injectSort
